import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function Loading() {
  return (
    <Box position='absolute' top={0} left={0}
      width='100%' height='100%' bgcolor='rgba(255, 255, 255, .5)'
    >
      <CircularProgress thickness={4} size={24}
        sx={{
          position: 'absolute',
          top: 'calc(50% - 12px)',
          left: 'calc(50% - 12px)'
        }}
      />
    </Box>
  );
};
